import type { ProposedAction, TaxStatus } from '@/types/rebalance'
import { TAX_STATUS_LABEL } from '@/lib/rebalanceLabels'

const TAX_STATUS_COLOR: Record<TaxStatus, string> = {
  steuerfrei: 'text-gain',
  voll_steuerpflichtig: 'text-loss',
  teilweise: 'text-bernstein',
  'n/a': 'text-faint',
}

interface ProposedActionItemProps {
  index: number
  action: ProposedAction
  onOrderTicket: (a: ProposedAction) => void
}

function formatEur(value: string): string {
  const num = Number(value)
  if (!Number.isFinite(num)) return value
  return num.toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export function ProposedActionItem({ index, action, onOrderTicket }: ProposedActionItemProps) {
  const isCashNegative = Number(action.cash_after) < 0
  const arrow = action.action === 'sell' ? '⬇' : '⬆'
  const verb = action.action === 'sell' ? 'verkaufen' : 'nachkaufen'

  return (
    <li
      className={[
        'flex flex-col gap-2 border-b border-hairline py-3 md:flex-row md:items-center md:gap-4',
        isCashNegative ? 'border-l-4 border-l-loss pl-3' : '',
      ].join(' ')}
    >
      <div className="flex-1">
        <p className="font-mono text-sm text-ink">
          {index}. {arrow}{' '}
          {action.cluster_name && (
            <span className="tracked-caps mr-2 text-[10px] text-muted">{action.cluster_name}</span>
          )}
          {action.ticker} {verb} {formatEur(action.eur_amount)} €
        </p>
        {action.action === 'sell' && (
          <p className={`mt-1 font-mono text-xs ${TAX_STATUS_COLOR[action.tax_status]}`}>
            {TAX_STATUS_LABEL[action.tax_status]}
            {action.kest_eur !== null && Number(action.kest_eur) > 0 && (
              <span className="ml-1">· {formatEur(action.kest_eur)} € KESt</span>
            )}
          </p>
        )}
        <p className={`mt-1 font-mono text-xs ${isCashNegative ? 'text-loss' : 'text-muted'}`}>
          Cash danach: {formatEur(action.cash_after)} €
          {isCashNegative && <span className="ml-1">⚠ Cash reicht nicht</span>}
        </p>
      </div>
      <button
        type="button"
        onClick={() => onOrderTicket(action)}
        className="tracked-caps w-full border border-hairline px-4 py-2 text-[10px] text-bernstein transition-colors hover:bg-panel md:w-auto print:hidden"
      >
        Order-Ticket → IBKR
      </button>
    </li>
  )
}
